import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../hooks/redux';
import { setCredentials } from '../../store/slices/authSlice';

const RedirectFacebook = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const value = queryParams.get('code');

  useEffect(() => {
    const facebookSignIn = async () => {
      try {
        const res = await fetch(`https://api-dev.travgenius.ai/users/sign-in/facebook/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            facebook_token: value,
          }),
        });

        if (!res.ok) {
          throw new Error('Failed to fetch redirect URL');
        }

        const data = await res.json();
        dispatch(setCredentials({ ...data }));
        localStorage.setItem('authToken', data.access);
        navigate('/profile');
      } catch (error) {
        console.error(error);
      }
    };

    facebookSignIn();
  }, [value]);

  return <div>Redirect Facebook</div>;
};

export default RedirectFacebook;
